// Renderer ESC/POS compartido por la caché offline. Mantenerlo alineado con
// backend/.../Services/EscposRenderer.php.
function lineWidth(widthMm) {
  return Number(widthMm) <= 58 ? 32 : 48
}

function renderCommands(content, config = {}) {
  const width = lineWidth(config.escpos_ticket_width_mm || 80)
  const dotsPerMm = 8
  const skipInit = content.includes('[[no-init]]')
  content = content.replace(/\[\[no-init\]\]/g, '')

  let header = skipInit ? '' : '\x1B\x40'
  const align = { left: '\x00', center: '\x01', right: '\x02' }
  header += '\x1B\x61' + (align[config.escpos_alignment || 'left'] || '\x00')
  header += '\x1B\x74\x02'

  const left = parseInt(config.escpos_margin_left_mm || 0)
  if(left > 0) {
    const units = Math.min(Math.round(left * dotsPerMm), 65535)
    header += '\x1D\x4C' + String.fromCharCode(units % 256) + String.fromCharCode(Math.floor(units / 256))
  }
  const right = parseInt(config.escpos_margin_right_mm || 0)
  if(right > 0) {
    const ticket = parseInt(config.escpos_ticket_width_mm || 80)
    const units = Math.min(Math.max(1, Math.round((ticket - left - right) * dotsPerMm)), 65535)
    header += '\x1D\x57' + String.fromCharCode(units % 256) + String.fromCharCode(Math.floor(units / 256))
  }
  const top = parseInt(config.escpos_margin_top_mm || 0)
  if(top > 0) header += '\x1B\x64' + String.fromCharCode(Math.min(Math.max(1, Math.round(top / 3.5)), 255))

  content = header + content
  const hr = '\x1B\x45\x01\x1B\x2D\x02' + ' '.repeat(width) + '\x1B\x2D\x00\x1B\x45\x00'
  content = content.split('[[hr]]').join(hr)

  const bottom = parseInt(config.escpos_margin_bottom_mm || 0)
  if(bottom > 0) {
    const feed = '\x1B\x64' + String.fromCharCode(Math.min(Math.max(1, Math.round(bottom / 3.5)), 255))
    ;['[[cut]]', '[[cut=full]]', '[[cut=partial]]'].forEach(tag => { content = content.split(tag).join(feed + tag) })
  }

  content = content.split('\n').map(line => {
    const columnTag = line.includes('[[col=small]]') ? '[[col=small]]' : '[[col]]'
    if(!line.includes(columnTag)) return line
    const [rawLeft, rawRight = ''] = line.split(columnTag)
    const leftText = rawLeft.trimEnd()
    const rightText = rawRight.trimStart()
    const clean = value => value.replace(/\[\[[^\]]+\]\]/g, '')
    const columnWidth = columnTag === '[[col=small]]' ? Math.round(width * 4 / 3) : width
    return leftText + ' '.repeat(Math.max(1, columnWidth - clean(leftText).length - clean(rightText).length)) + rightText
  }).join('\n')

  content = content.replace(/\[\[feed=(\d+)\]\]/g, (_, count) => '\x1B\x64' + String.fromCharCode(Math.min(parseInt(count), 255)))
  // ESC J avanza papel de manera puntual, sin modificar el interlineado base.
  content = content.replace(/\[\[feed-dots=(\d+)\]\]/g, (_, dots) => '\x1B\x4A' + String.fromCharCode(Math.min(Math.max(parseInt(dots), 1), 255)))
  // ESC 3 ajusta el avance entre líneas y ESC 2 restaura el predeterminado.
  // Debe mantenerse equivalente al renderer del backend para tickets offline.
  content = content.replace(/\[\[line-spacing=(\d+)\]\]/g, (_, dots) => '\x1B\x33' + String.fromCharCode(Math.min(Math.max(parseInt(dots), 1), 255)))
  content = content.split('[[line-spacing=default]]').join('\x1B\x32')
  const commands = {
    '[[align=left]]': '\x1B\x61\x00', '[[align=center]]': '\x1B\x61\x01', '[[align=right]]': '\x1B\x61\x02',
    '[[left]]': '\x1B\x61\x00', '[[center]]': '\x1B\x61\x01', '[[right]]': '\x1B\x61\x02',
    '[[bold]]': '\x1B\x45\x01', '[[bold=1]]': '\x1B\x45\x01', '[[bold:on]]': '\x1B\x45\x01',
    '[[/bold]]': '\x1B\x45\x00', '[[bold=0]]': '\x1B\x45\x00', '[[bold:off]]': '\x1B\x45\x00',
    '[[font=small]]': '\x1B\x4D\x01', '[[font=normal]]': '\x1B\x4D\x00',
    '[[big]]': '\x1D\x21\x11', '[[/big]]': '\x1D\x21\x00', '[[size=2]]': '\x1D\x21\x11',
    '[[size=dh]]': '\x1D\x21\x01', '[[size=dw]]': '\x1D\x21\x10', '[[size=1]]': '\x1D\x21\x00', '[[/size]]': '\x1D\x21\x00',
    '[[cut]]': '\x1D\x56\x00', '[[cut=full]]': '\x1D\x56\x00', '[[cut=partial]]': '\x1D\x56\x01',
  }
  Object.keys(commands).forEach(tag => { content = content.split(tag).join(commands[tag]) })
  return content
}

export default { lineWidth, renderCommands }
